
    import './styles.scoped.css';
    export default {
  "option": "awsui_option_1p2cx_aso3p_149",
  "disabled": "awsui_disabled_1p2cx_aso3p_186",
  "parent": "awsui_parent_1p2cx_aso3p_189",
  "highlighted": "awsui_highlighted_1p2cx_aso3p_192",
  "content": "awsui_content_1p2cx_aso3p_196",
  "label-content": "awsui_label-content_1p2cx_aso3p_203",
  "label": "awsui_label_1p2cx_aso3p_203",
  "tag": "awsui_tag_1p2cx_aso3p_210",
  "label-tag": "awsui_label-tag_1p2cx_aso3p_211",
  "label-prefix": "awsui_label-prefix_1p2cx_aso3p_221",
  "tags": "awsui_tags_1p2cx_aso3p_234",
  "description": "awsui_description_1p2cx_aso3p_235",
  "selected": "awsui_selected_1p2cx_aso3p_246",
  "icon": "awsui_icon_1p2cx_aso3p_260",
  "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_aso3p_267",
  "trigger-variant": "awsui_trigger-variant_1p2cx_aso3p_282",
  "custom-content": "awsui_custom-content_1p2cx_aso3p_288"
};
  